import Authors from './Authors';
import Benefits from './Benefits';
import Buy from './Buy';
import Header from './Header';
import { BookDiv, BookHero } from './styles';
import Testimonials from './Testimonials';

interface BookProps {
	bookBuyURL: string;
}

const Book = ({ bookBuyURL }: BookProps) => {
	return (
		<BookDiv>
			<Header bookBuyURL={bookBuyURL} />
			<BookHero role="presentation" />
			<Benefits />
			<Testimonials />
			<Buy bookBuyURL={bookBuyURL} />
			<Authors />
		</BookDiv>
	);
};
export default Book;
